<div class="only-mobile">
  <h1 class="h3">{{title}}</h1>
</div>

<div class="animated fadeIn">
  <!-- desktop structure -->
  <mat-tab-group class="vertical-tabs certificates-tabs" *ngIf="pantResolution >= 992">
    <mat-tab>
      <ng-template mat-tab-label>
        <div id="certificatesPermiss" class="mat-tab-label-content">
          <i class="rt-icon rt-certificates-private fs30"></i>
          {{ 'CERTIFICATES.TABS.PRIVATE.TITLE' | translate }}
        </div>
      </ng-template>
      <ng-template matTabContent>
        <app-private-certificates class="fix-parent-height-center-center"></app-private-certificates>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div id="preloadPermiss" class="mat-tab-label-content">
          <i class="rt-icon rt-certificates-activation-pending fs30"></i>
          {{ 'CERTIFICATES.TABS.PENDING.TITLE' | translate }}
        </div>
      </ng-template>
      <ng-template matTabContent>
        <app-pending-certificates class="fix-parent-height-center-center"></app-pending-certificates>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <!-- mobile structure -->
  <mat-accordion class="custom-accordeon parent certificates-accordeon" *ngIf="pantResolution < 992">
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <i class="rt-icon rt-certificates-private fs26 me-2"></i>
          {{ 'CERTIFICATES.TABS.PRIVATE.TITLE' | translate }}
          <div id="certificatesPermissMobile" class=""></div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
          <app-private-certificates></app-private-certificates>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <i class="rt-icon rt-certificates-activation-pending fs26 me-2"></i>
          {{ 'CERTIFICATES.TABS.PENDING.TITLE' | translate }}
          <div id="preloadPermissMobile" class=""></div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
          <app-pending-certificates></app-pending-certificates>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
